/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CurrentUserTenantsResponseDto } from './CurrentUserTenantsResponseDto';
export type CurrentUserResponseDto = {
  cognitoUserId: string;
  name?: string;
  surname?: string;
  email?: string;
  phoneNumber?: string;
  /**
   * Locale code
   */
  locale?: CurrentUserResponseDto.locale;
  groups: Array<string>;
  tenants: Array<CurrentUserTenantsResponseDto>;
  permissions: Array<string>;
  admin: boolean;
  tenant: boolean;
  client: boolean;
  app: boolean;
  emergencyContact: boolean;
  status: CurrentUserResponseDto.status;
  passwordExpiresAt: string;
  updatedAt: string;
  createdAt: string;
  onboardedAt?: string;
  legalDocAcceptedAt?: string;
  /**
   * Shows whether tenant requested mandatory multi-factor authentication (MFA) for this user.
   */
  mfaRequired: boolean;
  /**
   * Shows whether multi-factor authentication (MFA) is enabled for this user
   */
  mfaEnabled: boolean;
};
export namespace CurrentUserResponseDto {
  /**
   * Locale code
   */
  export enum locale {
    EN = 'EN',
    LV = 'LV',
    NO = 'NO',
    FI = 'FI',
  }
  export enum status {
    ACTIVE = 'ACTIVE',
    ACTIVATION_IN_PROGRESS = 'ACTIVATION_IN_PROGRESS',
    PENDING = 'PENDING',
    PENDING_IN_PROGRESS = 'PENDING_IN_PROGRESS',
    SUSPENDED = 'SUSPENDED',
    SUSPEND_IN_PROGRESS = 'SUSPEND_IN_PROGRESS',
    DEACTIVATED = 'DEACTIVATED',
    DEACTIVATE_IN_PROGRESS = 'DEACTIVATE_IN_PROGRESS',
    RESET = 'RESET',
    RESET_IN_PROGRESS = 'RESET_IN_PROGRESS',
  }
}

